export const SAVE_TRACK_RETURN = 'boilderplate/GstinFilingModal/SAVE_TRACK_RETURN';
export const SAVE_VALIDATION_DATA = 'boilderplate/GstinFilingModal/SAVE_VALIDATION_DATA';